import { create } from 'zustand';
import { BlogPost, GetNavListResponse } from '@/request/interface/resources';
import { SubMenu } from '@/components/Resources/types';

export interface Tag extends SubMenu {}

export interface ResourcesState {
  navList: GetNavListResponse['content'] | null;
  setNavList: (navList: GetNavListResponse['content']) => void;
  blogList: BlogPost[] | null;
  setBlogList: (blogList: BlogPost[]) => void;
  filterTags: Tag[];
  setFilterTags: (filterTags: Tag[]) => void;
}

const useResourcesStore = create<ResourcesState>((set) => ({
  navList: null,
  blogList: null,
  filterTags: [],
  setFilterTags: (filterTags: Tag[]) => set({ filterTags }),
  setNavList: (navList: GetNavListResponse['content']) => set({ navList }),
  setBlogList: (blogList: BlogPost[]) => set({ blogList }),
}));

export default useResourcesStore;
